module.exports = __webpack_public_path__ + "static/img/12.f7a206d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/12.png
// module id = M/uS
// module chunks = 0